// Hooks
import { useDesktopLogic } from 'app/shared/modules/MobileSRP/ListingCards/FilterPills/useDesktopLogic';
import { useMobileLogic } from 'app/shared/modules/MobileSRP/ListingCards/FilterPills/useMobileLogic';

export const useFilterPills = (isDesktop = false) => {
  const filterPillLogic = isDesktop ? useDesktopLogic : useMobileLogic;

  return filterPillLogic();
};
